import {isWithinDaysFromNow, isWithinYearsFromNow, formatDate} from '../DateUtil'

const Reassignable = {
  flagsOfficeHour: (subscription, subscriptionCodes, user) => {
    const results = []
    if (subscription.lineItem) {
      if (subscription.lineItem.isTemp) {
        results.push("is_temp")
      }
      // don't allow reassign if third party subscription
      if (subscription.lineItem.isThirdParty(subscriptionCodes)) {
        results.push("is_third_party")
      }
      if (!isWithinDaysFromNow(subscription.lineItem.processed_at, 7)) {
        results.push("processed_at_not_within_range")
      }
    }
    if (subscription.enrollment) {
      // shopper#324 : only allow reassignable if user is owner of the enrollment
      if (subscription.enrollment.ownedByOther(user)) {
        results.push('user_not_owner')
      }
    }
    return results
  },
  flags: (subscription, subscriptionCodes, user) => {
    const results = []
    if (subscription.lineItem) {
      if (subscription.lineItem.isTemp) {
        results.push("is_temp")
      }
      // don't allow reassign if third party subscription
      if (subscription.isThirdParty(subscriptionCodes)) {
        results.push("is_third_party")
      }
    }
    if (!subscription.enrollment) {
      results.push('no_enrollment')
    } else {
      if (!isWithinDaysFromNow(subscription.enrollment.start_at, 7)) {
        results.push('start_at_not_within_range')
      }
      // shopper#189 : hide if not role == student
      if (!subscription.enrollment.isRoleStudent) {
        results.push(`role_${subscription.enrollment.role}`)
      }
      if (["expired", "section_ended", "section_not_started", "disabled", "transferred"].indexOf(subscription.enrollment.status) != -1) {
        results.push(`invalid_status_${subscription.enrollment.status}`)
      }
      if (subscription.enrollment.isTemp) {
        results.push("is_temp_enroll")
      }
      if (!subscription.enrollment.start_at) {
        results.push('no_start_at')
      }

      // shopper#149 : only allow if user is owner of the enrollment
      if (!user.is(subscription.enrollment.owner)) {
        results.push('user_not_owner')
      }

      // hide if user_assigned_registration = false
      // shopper#861 : and not legacy
      if (!subscription.enrollment.isUserAssignedRegistration && !subscription.isClassroom) {
        results.push('no_user_assigned_registration')
      }

      // shopper#205 : hide if deactivated
      if (subscription.enrollment.isDeactivated) {
        results.push('deactivated')
      }

      if (subscription.enrollment.isRetaken) {
        results.push('enrollment_retaken')
      }
    }

    return results
  }
}

export default Reassignable
